import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

import { PlayPage } from '../play/play'; 
import { HomePage } from '../home/home';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { GamerulesModel } from '../../providers/gamerules-model';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-versusai',
  templateUrl: 'versusai.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class VersusAIPage {
  language: string;
  settingsChanged:boolean;
  usernamePlayerChosenToStartPvpAsync:string ='';
  playerData;
  gamesdataPVPAsync: any =[];
  refreshIntervalId;
  randomPlayerData: any;

  constructor(public rubedoSideMenu: MenuController, public functions: Functions, public toastCtrl: ToastController, public translate: TranslateService, public navCtrl: NavController, public gamesrulesModel: GamerulesModel, public userdataModel:UserdataModel, public dataExchanger:DataExchanger, public playModel: GameModel) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.language = '';
    this.settingsChanged=false;
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setLanguage();
    if (this.settingsChanged) {
      this.dataExchanger.storeUserGamedataOnServer(true);
      console.log("Setting changed... saving on server");
    }
    this.settingsChanged=false;
    clearInterval(this.refreshIntervalId);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.getLanguage();
    this.settingsChanged=false;
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  /* --------- END LIFECYCLE --------- */

  startPlayVersusAI(){   
    this.functions.setGameModeVersus(true);
    this.navCtrl.push(PlayPage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/versusai/versusai.ts